import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function LoadingSkeleton() {
    return (
        <React.Fragment>
            <div >
                <Skeleton count={1} height={66} width={"100%"} />
                <Skeleton count={1} height={66} width={"100%"} />
            </div>
            <div style={{ marginBottom: 1 }}>
                <Skeleton count={1} height={66} width={"100%"} />
            </div>
            <div style={{ marginBottom: 1 }}>
                <Skeleton count={1} height={66} width={"100%"} />
            </div>
        </React.Fragment>
    )
}

export default memo(LoadingSkeleton)